import PlusIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ForwardBackButtons } from "core/components/ForwardBackButtons";
import type { WeatherWidgetViewComponentProps } from "features/Weather/entities";
import { useTranslation } from "react-i18next";
import { WeatherIcon } from "../WeatherIcon";

export function DesktopWeatherWidget({
  externalLink,
  weatherCurrent,
  location,
  nextLocation,
  nextLocationDisabled,
  previousLocation,
  previousLocationDisabled,
  showControls,
}: WeatherWidgetViewComponentProps) {
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Weather:DesktopWeatherWidget",
  });
  return (
    <>
      <Paper
        sx={{
          backgroundColor: "primary.main",
          color: "primary.contrastText",
          p: 3,
          height: "100%",
          minHeight: "365px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack
          direction="row"
          alignItems="flex-start"
          justifyContent="space-between"
        >
          <Typography variant="body2">{`${location.city}`}</Typography>
          {showControls && (
            <ForwardBackButtons
              variant="outlined"
              sx={{ color: "primary.contrastText" }}
              disableElevation
              onBackClick={previousLocation}
              onForwardClick={nextLocation}
              backDisabled={previousLocationDisabled}
              forwardDisabled={nextLocationDisabled}
              color="inherit"
              size="small"
            />
          )}
        </Stack>

        <Stack alignItems="center" gap={1}>
          <WeatherIcon code={weatherCurrent.code} fontSize="5rem" />
          <Typography variant="subtitle1" color="lighten.50">
            {weatherCurrent.date}
          </Typography>
          <Stack alignItems="center">
            <Typography variant="body2" color="lighten.50">
              {t("current")}
            </Typography>
            <Typography variant="h3">{weatherCurrent.tempCurrent}</Typography>
          </Stack>
          <Stack direction="row" justifyContent="center" gap={4}>
            <Stack alignItems="center">
              <Typography variant="body2" color="lighten.50">
                {t("low")}
              </Typography>
              <Typography variant="h5">{weatherCurrent.tempLow}</Typography>
            </Stack>
            <Stack alignItems="center">
              <Typography variant="body2" color="lighten.50">
                {t("high")}
              </Typography>
              <Typography variant="h5">{weatherCurrent.tempHigh}</Typography>
            </Stack>
          </Stack>
        </Stack>
      </Paper>
      <Stack direction="row" justifyContent="flex-end" height="40px" mt={1}>
        <Button href={externalLink} target="_blank" startIcon={<PlusIcon />}>
          {t("moreDetails")}
        </Button>
      </Stack>
    </>
  );
}
